/** Deep-strip undefined values — Firebase rejects any undefined in update() */
export function stripUndefined(obj) {
  if (obj === null || obj === undefined) return null;
  if (Array.isArray(obj)) return obj.map(stripUndefined);
  if (typeof obj === 'object' && obj.constructor === Object) {
    const clean = {};
    for (const [k, v] of Object.entries(obj)) {
      if (v !== undefined) clean[k] = stripUndefined(v);
    }
    return clean;
  }
  return obj;
}

/** Check if a value is "empty" (null, undefined, empty array, empty object) */
export function isEmptyValue(v) {
  if (v === null || v === undefined) return true;
  if (Array.isArray(v) && v.length === 0) return true;
  if (typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0) return true;
  return false;
}

/** Convert Firebase value (object or array with possible nulls) to a plain array */
export function toPlainArray(v, fallback = []) {
  if (v === null || v === undefined) return fallback;
  if (Array.isArray(v)) return v.filter(item => item != null);
  if (typeof v === 'object') {
    const vals = Object.values(v).filter(item => item != null);
    return vals.length > 0 ? vals : fallback;
  }
  return fallback;
}
